module.exports = __webpack_public_path__ + "static/media/02-09.9aeace8a.png";